module.exports = require('./helpers/bundle-url').getBundleURL('hB35s') + "logo-dark.eefe0b7f.svg";